const baseStyle = {
  color: "black",
  fontWeight: 700,
};

export { baseStyle };
